import { useCallback } from 'react';

import { printDocumentAsPdf } from '@dreryk/react-common';
import { ActionBar, ButtonVariant, componentsTranslationKeys } from '@dreryk/react-components';

import { DocumentTemplateFormController } from '~libs.desktop.shared.document-template';

import { usePushBackToVisit } from '../../../shared/hooks/usePushBackToVisit';
import { translationKeys } from '../translations';

import { VisitDocumentApproveActionInterceptor } from './interceptors/VisitDocumentApproveActionInterceptor';
import { VisitApproveOnSuccessCallback } from './interceptors/VisitDocumentApproveActionInterceptor.types';

type VisitDocumentApproveAndPrintActionProps = Pick<DocumentTemplateFormController, 'handleSubmit' | 'markPristine'> & {
   readonly patientId: number;
   readonly printTemplateId: number;
   readonly visitId: number;
};

export const VisitDocumentApproveAndPrintAction = (props: VisitDocumentApproveAndPrintActionProps): JSX.Element => {
   const pushBackToVisit = usePushBackToVisit(props.visitId);
   const handleSuccess = useCallback<VisitApproveOnSuccessCallback>(async ({ document }) => {
      await printDocumentAsPdf({ base64: document.data });
   }, []);

   return (
      <VisitDocumentApproveActionInterceptor
         patientId={props.patientId}
         visitId={props.visitId}
         printTemplateId={props.printTemplateId}
         handleSubmit={props.handleSubmit}
         markPristine={props.markPristine}
         onSuccess={handleSuccess}
      >
         <ActionBar.PrimaryButton
            variant={ButtonVariant.PRIMARY}
            onClick={pushBackToVisit}
            label={translationKeys.confirmAndPrint}
            testId={'confirmAndPrint'}
            blockingOperation={componentsTranslationKeys.savingData}
         />
      </VisitDocumentApproveActionInterceptor>
   );
};
